import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IAppConfig } from '@app/store/models/config.interface';
import { Subject, Subscription } from 'rxjs';
import { APP_CONFIG } from 'src/app/modules/core/config/config';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { PreparedPopupGeneratedRecordInterface } from '@app/store/models/prepared-popup-generated-record.interface';

@Component({
    selector: 'app-popups-wrapper',
    templateUrl: './popups-wrapper.component.html',
    styleUrls: ['./popups-wrapper.component.scss']
})
export class PopupsWrapperComponent implements OnInit {
    short_id: string
    session_info: SessionInfo
    private subscriptions: Subscription[] = []
    popup_details: PreparedPopupGeneratedRecordInterface
    history_obs: Subject<PreparedPopupGeneratedRecordInterface> = new Subject<PreparedPopupGeneratedRecordInterface>()

    constructor(
        private httpClient: HttpClient,
        private activatedRoute: ActivatedRoute,
        public readonly coreService: CoreService,
        private functionService: FunctionsService,
        @Inject(APP_CONFIG) private readonly config: IAppConfig
    ) {
        this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
    }

    ngOnInit(): void {
        this.subscriptions.push(this.activatedRoute.params.subscribe(p => {
            this.short_id = p["id"]
            this.getData()
        }))
    }

    ngOnDestroy(): void {
        this.subscriptions.map(s => s.unsubscribe())
    }

    private fillResponse(history: PreparedPopupGeneratedRecordInterface) {
        if (!history) return
        this.history_obs.next(history)
        this.popup_details = history
        this.session_info.cache.popup_viewing = this.popup_details
        this.coreService.setSessionData(this.session_info, false)
    }

    async getData() {
        this.popup_details = null
        const found_in_cache = this.session_info.cache.popup_viewing?.short_id === this.short_id
        if (found_in_cache) {
            this.popup_details = this.session_info.cache.popup_viewing
        }
        try {
            const history: PreparedPopupGeneratedRecordInterface = (await this.httpClient.get(`${this.config.apiEndpoints.popups.data}${this.short_id}`, { headers: { "skip-message": "true" } }).toPromise() as any).popup_details
            this.fillResponse(history)
        } catch (error) {
            this.functionService.logToConsole(error)
        }
    }

}
